// extracted by mini-css-extract-plugin
export default {"cardView":"AddEditEnquiry_cardView__Vgeb9","titleText":"AddEditEnquiry_titleText__3JqFe","requiredText":"AddEditEnquiry_requiredText__sAtqt"};